/***********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
8.19.20

***********************************************************/
import React, { Component } from 'react';
import { Sparklines, SparklinesLine, SparklinesReferenceLine } from 'react-sparklines';
import commafy from 'commafy-anything';
import IrrigationInfoCard from './irrigation_info_card';
import { sumProp, avgProp } from '../../irrigation_utils';

class IrrigationIntroSummary extends Component {
  render() {
    return (
      <div className="row">
        <div className="col s12 m6 l3 xl3">
          <IrrigationInfoCard
            header={'Total Gallons of Water'}
            icon={'opacity'}
            data={`${commafy(Number(sumProp('totalGal', this.props.valveTotals)))}`}
            color={'blue'}
            avg1={<div>Avg Gallon/Valve: <b>{commafy(Number(avgProp('totalGal', this.props.valveTotals)))}</b></div>}
            child={<Sparklines data={this.props.valveTotals.map((e) => e.totalGal)} height={20}>
              <SparklinesLine style={{ stroke: "white", strokeWidth: "1", fill: "#bbdefb", fillOpacity: "0.5" }}  />
              <SparklinesReferenceLine type="mean" />
            </Sparklines>}
           />
        </div>
        <div className="col s12 m6 l3 xl3">
          <IrrigationInfoCard
            header={'Total Engine Hours'}
            icon={'hourglass_empty'}
            data={commafy(Number(sumProp('totalHours', this.props.engineTotals)))}
            color={'teal'}
            avg1={<div>Avg Hours/Engine: <b>{commafy(Number(avgProp('totalHours', this.props.engineTotals)))}</b></div>}
            child={<Sparklines data={this.props.engineTotals.map((e) => e.totalHours)} height={20}>
              <SparklinesLine style={{ stroke: "white", strokeWidth: "1", fill: "#b2dfdb", fillOpacity: "0.5" }}  />
              <SparklinesReferenceLine type="mean" />
            </Sparklines>}
           />
        </div>
        <div className="col s12 m6 l3 xl3">
          <IrrigationInfoCard
            header={'Total Gallons of Fuel'}
            icon={'waves'}
            data={commafy(Number(sumProp('totalFuelGal', this.props.engineTotals)))}
            color={'indigo'}
            avg1={<div>Avg Fuel/Engine: <b>{commafy(Number(avgProp('totalFuelGal', this.props.engineTotals)))}</b></div>}
            child={<Sparklines data={this.props.engineTotals.map((e) => e.totalFuelGal)} height={20}>
              <SparklinesLine style={{ stroke: "white", strokeWidth: "1", fill: "#c5cae9", fillOpacity: "0.5" }}  />
              <SparklinesReferenceLine type="mean" />
            </Sparklines>}
           />
        </div>
        <div className="col s12 m6 l3 xl3">
          <IrrigationInfoCard
            header={'Total Fuel Cost'}
            icon={'monetization_on'}
            data={`$${commafy(Number(sumProp('totalFuelCost', this.props.engineTotals)))}`}
            color={'red'}
            avg1={<div>Avg Fuel Cost/Engine: <b>${commafy(Number(avgProp('totalFuelCost', this.props.engineTotals)))}</b></div>}
            child={<Sparklines data={this.props.engineTotals.map((e) => e.totalFuelCost)} height={20}>
              <SparklinesLine style={{ stroke: "white", strokeWidth: "1", fill: "#ffcdd2", fillOpacity: "0.5" }}  />
              <SparklinesReferenceLine type="mean" />
            </Sparklines>}
           />
        </div>
      </div>
    )
  }
}

export default IrrigationIntroSummary;




/* END */



// WEBPACK FOOTER //
// ./src/irrigation/components/dashboard/irrigation_intro_summary.js